import { Component } from '@angular/core';

@Component({
  templateUrl: './new.component.html',
  styleUrls: ['./new.component.css'],
})
export class NewComponent {

  constructor() { }

}
